import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "./ui/dialog";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { useMobileDialogStyle } from "../hooks/useVisualViewport";

const pad = (n) => String(n).padStart(2, "0");
const nowHM = () => { const d = new Date(); return `${pad(d.getHours())}:${pad(d.getMinutes())}`; };
const nowLocalIso = () => { const d = new Date(); return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}:00`; };

// Compact "effective time" chooser for Avvia / Termina. Default = "Adesso" (wall-clock local);
// "Altro orario" reveals a correctable HH:MM combined with the activity's date. NO autofocus.
export function ActivityTimeDialog({ open, mode, date, minTime, onConfirm, onClose }) {
  const dlgStyle = useMobileDialogStyle();
  const isStart = mode === "start";
  const [choice, setChoice] = useState("now");
  const [hm, setHm] = useState(nowHM());
  const [err, setErr] = useState("");
  useEffect(() => { if (open) { setChoice("now"); setHm(nowHM()); setErr(""); } }, [open]);

  const confirm = () => {
    let iso;
    if (choice === "now") iso = nowLocalIso();
    else {
      if (!hm) { setErr("Inserisci un orario"); return; }
      iso = `${date}T${hm}:00`;
    }
    if (!isStart && minTime && iso < minTime) {
      setErr("L'ora di fine non può precedere l'ora di inizio."); return;
    }
    onConfirm(iso);
  };

  const optCls = (active) =>
    `flex-1 h-11 rounded-lg border text-sm font-medium transition-colors ${active
      ? "border-[#1B5E20] bg-[#E8F5E9] text-[#1B5E20]"
      : "border-[#E5DEC9] bg-white text-[#5F6B64] hover:border-[#8C532B]"}`;

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="activity-time-dialog" style={dlgStyle} className="max-w-[380px]">
        <DialogHeader>
          <DialogTitle>{isStart ? "Avvia attività" : "Termina attività"}</DialogTitle>
          <DialogDescription>{isStart ? "Ora effettiva di inizio" : "Ora effettiva di fine"}</DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <div className="flex gap-2">
            <button type="button" data-testid="time-choice-now" className={optCls(choice === "now")} onClick={() => { setChoice("now"); setErr(""); }}>
              Adesso — {nowHM()}
            </button>
            <button type="button" data-testid="time-choice-other" className={optCls(choice === "other")} onClick={() => { setChoice("other"); setErr(""); }}>
              Altro orario
            </button>
          </div>
          {choice === "other" && (
            <Input type="time" data-testid="time-other-input" value={hm} onChange={(e) => { setHm(e.target.value); setErr(""); }} className="h-11" />
          )}
          {err && <p className="text-xs text-red-600" data-testid="time-error">{err}</p>}
        </div>
        <DialogFooter className="gap-2">
          <Button variant="outline" data-testid="time-cancel" onClick={onClose}>Annulla</Button>
          <Button data-testid="time-confirm" onClick={confirm}
            className="bg-[#1B3B2B] hover:bg-[#142E1F]">{isStart ? "Avvia" : "Termina"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
